import { render, staticRenderFns } from "./zcfzb.vue?vue&type=template&id=0cb2ee34&scoped=true"
import script from "./zcfzb.vue?vue&type=script&lang=js"
export * from "./zcfzb.vue?vue&type=script&lang=js"
import style0 from "./zcfzb.vue?vue&type=style&index=0&id=0cb2ee34&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb2ee34",
  null
  
)

export default component.exports